/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginDto } from '../../models/login-dto';
import { LoginRespose } from '../../models/login-respose';

export interface AuthToken$Params {
      body: LoginDto
}

export function authToken(http: HttpClient, rootUrl: string, params: AuthToken$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginRespose>> {
  const rb = new RequestBuilder(rootUrl, authToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginRespose>;
    })
  );
}

authToken.PATH = '/Auth/Token';
